import React, {PureComponent} from 'react';
import {FastField} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormGroup from '../FormGroup';
import CommonFields from './CommonFields';
import Error from '../../../Error';

class Number1Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <FormGroup name={`${name}.min`} label={messages.surveys.form.label.min} size={3} tooltip={messages.surveys.form.tooltip.min}>
                        <FastField id={`${name}.min`} name={`${name}.min`} type="number" step="any"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.min`) && (get(form.touched, `${name}.min`) || form.submitCount > 0)})} />
                        {(get(form.touched, `${name}.min`) || form.submitCount > 0) && get(form.errors, `${name}.min`) &&
                            <Error reason={get(form.errors, `${name}.min`).key} reasonParams={get(form.errors, `${name}.min`).params} />}
                    </FormGroup>
                    <FormGroup name={`${name}.max`} label={messages.surveys.form.label.max} size={3} tooltip={messages.surveys.form.tooltip.max}>
                        <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.max`) && (get(form.touched, `${name}.max`) || form.submitCount > 0)})} />
                        {(get(form.touched, `${name}.max`) || form.submitCount > 0) && get(form.errors, `${name}.max`) &&
                            <Error reason={get(form.errors, `${name}.max`).key} reasonParams={get(form.errors, `${name}.max`).params} />}
                    </FormGroup>
                    <FormGroup name={`${name}.step`} label={messages.surveys.form.label.step} size={3} tooltip={messages.surveys.form.tooltip.step}>
                        <FastField id={`${name}.step`} name={`${name}.step`} type="number" step="any"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.step`) && (get(form.touched, `${name}.step`) || form.submitCount > 0)})} />
                        {(get(form.touched, `${name}.step`) || form.submitCount > 0) && get(form.errors, `${name}.step`) &&
                            <Error reason={get(form.errors, `${name}.step`).key} reasonParams={get(form.errors, `${name}.step`).params} />}
                    </FormGroup>
                </div>
            </>
        );
    }
}

export default Number1Type;
